import React from 'react';

/**
 * Top-level error boundary so any uncaught render error shows a friendly
 * recovery screen instead of a blank white page.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReset = () => {
    try {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
    } catch (e) {
      /* ignore */
    }
    window.location.assign('/login');
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0F172A] to-[#1E3A8A] px-4">
        <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md text-center">
          <h1 className="font-oswald text-2xl font-bold text-[#1E3A8A] uppercase mb-3">
            Something went wrong
          </h1>
          <p className="text-slate-600 mb-6">
            We hit an unexpected error. Try reloading; if it keeps happening, sign in again.
          </p>
          <pre className="text-xs text-slate-400 bg-slate-50 rounded p-2 max-h-32 overflow-auto text-left mb-4">
            {String(this.state.error?.message || this.state.error || 'Unknown error').slice(0, 300)}
          </pre>
          <div className="flex gap-2 justify-center">
            <button
              onClick={this.handleReload}
              className="bg-[#1E3A8A] hover:bg-[#172554] text-white font-semibold px-4 py-2 rounded-md"
            >
              Reload page
            </button>
            <button
              onClick={this.handleReset}
              className="bg-slate-200 hover:bg-slate-300 text-slate-800 font-semibold px-4 py-2 rounded-md"
            >
              Sign in again
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
